import { applePayPossible } from "@/services/apple-pay";

const PAYMENT_METHODS = {
  "paypal": { options: ["paypal"] },
  "cc": { options: ["visa", "mastercard", "amex"] }
};

if (applePayPossible()) {
  PAYMENT_METHODS.applePay = { options: ["applePay"] };
}

// PayPal does not operate in Turkey:
// https://techcrunch.com/2016/05/31/paypal-to-halt-operations-in-turkey-after-losing-license-impacts-hundreds-of-thousands/
const PAYMENT_METHODS_DISABLED_BY_LOCATION = {
  "tr": ["paypal"],
  "in": ["paypal"],
  "il": ["paypal"]
};

// PayPal's list of supported currencies:
// https://developer.paypal.com/docs/classic/api/currency_codes/
const PAYMENT_METHODS_DISABLED_BY_CURRENCY = {
  "zar": ["paypal"],
  "krw": ["paypal"],
  "inr": ["paypal"]
};

const PAYMENT_OPTIONS_DISABLED_BY_LOCATION = { "in": ["amex"] };

const PAYMENT_OPTIONS_DISABLED_BY_CURRENCY = { "inr": ["amex"] };

const enabledPaymentMethods = (
  currency,
  location,
  paymentMethods = PAYMENT_METHODS,
  paymentMethodsDisabledByLocation = PAYMENT_METHODS_DISABLED_BY_LOCATION,
  paymentMethodsDisabledByCurrency = PAYMENT_METHODS_DISABLED_BY_CURRENCY,
  paymentOptionsDisabledByLocation = PAYMENT_OPTIONS_DISABLED_BY_LOCATION,
  paymentOptionsDisabledByCurrency = PAYMENT_OPTIONS_DISABLED_BY_CURRENCY
) => {
  const enabledMethods = {};

  Object.entries(paymentMethods).forEach(([key, entry]) => {
    const isMethodEnabledByLocation = !paymentMethodsDisabledByLocation[location]
      || paymentMethodsDisabledByLocation[location].indexOf(key) < 0;

    const isMethodEnabledByCurrency = !paymentMethodsDisabledByCurrency[currency]
      || paymentMethodsDisabledByCurrency[currency].indexOf(key) < 0;

    if (isMethodEnabledByLocation && isMethodEnabledByCurrency) {
      const enabledOptions = entry.options.filter(entry => {
        const isOptionEnableddByLocation = !paymentOptionsDisabledByLocation[location]
          || paymentOptionsDisabledByLocation[location].indexOf(entry) < 0;

        const isOptionEnabledByCurrency = !paymentOptionsDisabledByCurrency[currency]
          || paymentOptionsDisabledByCurrency[currency].indexOf(entry) < 0;

        return isOptionEnableddByLocation && isOptionEnabledByCurrency;
      });

      enabledMethods[key] = {
        ...entry,
        options: enabledOptions
      };
    }
  });

  return enabledMethods;
};

export default enabledPaymentMethods;
